import React, { useEffect, useState, useRef } from 'react'
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import HorizontalLinearStepper from './HorizontalLinearStepper';


function Reserveroom() {

   
    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content"><br />
                    <div className="container-fluid">
                        <div className="row">
                            <HorizontalLinearStepper />
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Reserveroom
